import { create } from 'zustand';

type StoreStates = {
  open: boolean;
};
type StoreActions = {
  handleOpen: VoidFunction;
  handleClose: VoidFunction;
};
type StoreClaimNumbers = StoreStates & StoreActions;

const initialValues = {
  open: false,
};

export const claimNumbersModalStore = create<StoreClaimNumbers>((set) => ({
  ...initialValues,
  handleOpen: () => set(() => ({ open: true })),
  handleClose: () => set(() => ({ open: false })),
}));
